import { menuGroup, menuItem } from "modules/helpers";

// standard components
import FormatBoolean from "./FormatBoolean.doc";
import FormatDate from "./FormatDate.doc";
import FormatDateTime from "./FormatDateTime.doc";
import FormatNumber from "./FormatNumber.doc";
import FormatTime from "./FormatTime.doc";

const standardComponents = [
  menuItem("<Format.Boolean/>", "format-boolean", FormatBoolean),
  menuItem("<Format.Date/>", "format-date", FormatDate),
  menuItem("<Format.DateTime/>", "format-date-time", FormatDateTime),
  menuItem("<Format.Number/>", "format-number", FormatNumber),
  menuItem("<Format.Time/>", "format-time", FormatTime),
];

// extended components
import FormatHtml from "./FormatHtml.doc";

const extendedComponents = [
  menuItem("<FormatHtml/>", "format-html", FormatHtml),
];

// hooks
import UseBooleanFormatter from "./UseBooleanFormatter.doc";
import UseDateFormatter from "./UseDateFormatter.doc";
import UseDateTimeFormatter from "./UseDateTimeFormatter.doc";
import UseNumberFormatter from "./UseNumberFormatter.doc";
import UseTimeFormatter from "./UseTimeFormatter.doc";

const hooks = [
  menuItem("useBooleanFormatter", "use-boolean-formatter", UseBooleanFormatter),
  menuItem("useDateFormatter", "use-date-formatter", UseDateFormatter),
  menuItem(
    "useDateTimeFormatter",
    "use-date-time-formatter",
    UseDateTimeFormatter
  ),
  menuItem("useNumberFormatter", "use-number-formatter", UseNumberFormatter),
  menuItem("useTimeFormatter", "use-time-formatter", UseTimeFormatter),
];

export default [
  menuGroup("Standard Components", "standard-components", standardComponents),
  menuGroup("Extended Components", "extended-components", extendedComponents),
  menuGroup("Hooks", "hooks", hooks),
];
